import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useOperators } from './operators';

/**
 * Composable that provides knowledge base filtering context
 * @returns {{ filterTypes: import('vue').ComputedRef }}
 */
export function useKnowledgeBaseFilterContext() {
  const { t } = useI18n();

  const {
    equalityOperators,
    containmentOperators,
    dateOperators,
    comparisonOperators,
  } = useOperators();

  /**
   * @type {import('vue').ComputedRef}
   */
  const filterTypes = computed(() => [
    {
      attributeKey: 'name',
      value: 'name',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FILTER.NAME'),
      label: t('PILOT.KNOWLEDGE_BASES.FILTER.NAME'),
      inputType: 'plainText',
      dataType: 'text',
      filterOperators: containmentOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'description',
      value: 'description',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FILTER.DESCRIPTION'),
      label: t('PILOT.KNOWLEDGE_BASES.FILTER.DESCRIPTION'),
      inputType: 'plainText',
      dataType: 'text',
      filterOperators: containmentOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'status',
      value: 'status',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FILTER.STATUS'),
      label: t('PILOT.KNOWLEDGE_BASES.FILTER.STATUS'),
      inputType: 'searchSelect',
      options: [
        {
          id: 'draft',
          name: t('PILOT.KNOWLEDGE_BASES.STATUS.DRAFT'),
        },
        {
          id: 'published',
          name: t('PILOT.KNOWLEDGE_BASES.STATUS.PUBLISHED'),
        },
      ],
      dataType: 'text',
      filterOperators: equalityOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'documents_count',
      value: 'documents_count',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FILTER.DOCUMENTS_COUNT'),
      label: t('PILOT.KNOWLEDGE_BASES.FILTER.DOCUMENTS_COUNT'),
      inputType: 'plainText',
      dataType: 'number',
      filterOperators: comparisonOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'assistants_count',
      value: 'assistants_count',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FILTER.ASSISTANTS_COUNT'),
      label: t('PILOT.KNOWLEDGE_BASES.FILTER.ASSISTANTS_COUNT'),
      inputType: 'plainText',
      dataType: 'number',
      filterOperators: comparisonOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'created_at',
      value: 'created_at',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FILTER.CREATED_AT'),
      label: t('PILOT.KNOWLEDGE_BASES.FILTER.CREATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'updated_at',
      value: 'updated_at',
      attributeName: t('PILOT.KNOWLEDGE_BASES.FILTER.UPDATED_AT'),
      label: t('PILOT.KNOWLEDGE_BASES.FILTER.UPDATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
  ]);

  return { filterTypes };
}
